// https://stackoverflow.com/questions/29805909/jquery-how-to-check-if-uploaded-file-is-an-image-without-checking-extensions#answer-37103282
export const isValidImage = (file: File) => file instanceof File && file.type.includes('image');
